<div id="fixed" class="parent-container">
    <div fxLayout="row" class="w-100 crumb-c" fxLayoutAlign="space-between center">
        <div fxLayout="row" class="w-100 bleft" fxLayoutAlign="space-between center">
            <admin-breadcrumb></admin-breadcrumb>
            <div fxLayout="row" fxLayoutAlign="end center"></div>

            <div fxLayout="row" class="addBar" fxLayoutAlign="end center">
                <div fxLayout="row" class="location" fxLayoutAlign="center">

                </div>
            </div>
        </div>
        <div *ngIf="assignment_access.POST" class="leftpadding">
            <button (click)="openDialog('createAssignment')" mat-button class="greenbutton size-M">Create Assignment </button>
        </div>
    </div>

    <div class="master-container">
        <!-- BLOCK 1 START ----------------------------------------------------------------------------------------------- -->
        <div class="mcontainer border-left">
            <div class="title-ap">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="fixed-width cnt">
                        <mat-select (openedChange)="search_year=''"  [(ngModel)]="selected_year"  (selectionChange)="selectionChange()" placeholder="Select year"class="form-select-l f-dropdown-w-80">
                            <div class="search_bar"><input [(ngModel)]="search_year" [ngModelOptions]="{standalone: true}"
                                placeholder="Search..." (keydown)="$event.stopPropagation()" /></div>
                            <mat-option *ngFor="let year of yearList | searchFilter :'val':search_year:yearList" [value]="year.val">
                                {{year.label}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="fixed-width cnt">
                        <mat-select (openedChange)="searchAssignType=''" (selectionChange)="selectionChange()" placeholder="Select Assignment Type" [(ngModel)]="selectedAssignType" class="form-select-l f-dropdown-w-80">
                            <div class="search_bar"> <input mat-input [(ngModel)]="searchAssignType" placeholder="Type here to search name..." (keydown)="$event.stopPropagation()" /></div>
                            <mat-option *ngFor="let type of assignment_type | searchfilter:'label':searchAssignType:assignment_type" [value]="type.name">{{type.label}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="fixed-width cnt">
                        <mat-select (selectionChange)="selectionChange()" placeholder="Status" [(ngModel)]="checked_status" class="form-select-l f-dropdown-w-80">
                            <mat-option *ngFor="let sta of status_list" [value]="sta.value">{{sta.label}}</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div *ngIf="selectedAssignment?.status != -3" class="section-right d-flex justify-content-between align-items-center">
                    <button class="copy" matTooltip="copy" (click)="codyAssignment()" [class.active]="this.selectedAssignment?.id">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="20" height="20" x="0" y="0" viewBox="0 0 699.428 699.428" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g>
                            <g xmlns="http://www.w3.org/2000/svg">
                                <g id="_x33__21_">
                                    <g>
                                        <path d="M502.714,0c-2.71,0-262.286,0-262.286,0C194.178,0,153,42.425,153,87.429l-25.267,0.59     c-46.228,0-84.019,41.834-84.019,86.838V612c0,45.004,41.179,87.428,87.429,87.428H459c46.249,0,87.428-42.424,87.428-87.428     h21.857c46.25,0,87.429-42.424,87.429-87.428v-349.19L502.714,0z M459,655.715H131.143c-22.95,0-43.714-21.441-43.714-43.715     V174.857c0-22.272,18.688-42.993,41.638-42.993L153,131.143v393.429C153,569.576,194.178,612,240.428,612h262.286     C502.714,634.273,481.949,655.715,459,655.715z M612,524.572c0,22.271-20.765,43.713-43.715,43.713H240.428     c-22.95,0-43.714-21.441-43.714-43.713V87.429c0-22.272,20.764-43.714,43.714-43.714H459c-0.351,50.337,0,87.975,0,87.975     c0,45.419,40.872,86.882,87.428,86.882c0,0,23.213,0,65.572,0V524.572z M546.428,174.857c-23.277,0-43.714-42.293-43.714-64.981     c0,0,0-22.994,0-65.484v-0.044L612,174.857H546.428z M502.714,306.394H306c-12.065,0-21.857,9.77-21.857,21.835     c0,12.065,9.792,21.835,21.857,21.835h196.714c12.065,0,21.857-9.771,21.857-21.835     C524.571,316.164,514.779,306.394,502.714,306.394z M502.714,415.57H306c-12.065,0-21.857,9.77-21.857,21.834     c0,12.066,9.792,21.836,21.857,21.836h196.714c12.065,0,21.857-9.77,21.857-21.836C524.571,425.34,514.779,415.57,502.714,415.57     z" fill="" data-original="#000000" class=""></path>
                                    </g>
                                </g>
                            </g>
                            </g>
                        </svg>
                    </button>
                </div>

            </div>
            <div class="block_1_search">
                <div class="inputbox">
                    <input class="search-input" [formControl]="searchAssignment" placeholder="Search assignment">
                    <mat-icon class="iconM">search</mat-icon>
                </div>
            </div>


            <div id="block1" class="list-container" (scroll)="onscrollAssign($event)">
                <div *ngIf="loader1" class='loader-div'>
                    <ngx-loading [show]="loader1" [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.3)'}">
                    </ngx-loading>
                </div>
                <div *ngFor="let data of masterList" [ngClass]="{'select':isActive(data.id)}" class="list-itm" (click)="getAllocatedUsers(data, 'user');$event.stopPropagation();">
                    <div class="listHeading">
                        <div class="name assign-name"><span>{{data.label}}_{{data?.year}}</span></div>
                        <div class="action" *ngIf="data?.status != -3">
                            <div *ngIf="assignment_access.PATCH" (click)="getAllocatedUsers(data, 'dialog')" class="edit">
                                <mat-icon class="editIcon" svgIcon="edit"></mat-icon>
                            </div>
                            <div *ngIf="assignment_access.PATCH" class="toggle" (click)="$event.stopPropagation()">
                                <label class="switch">
                                    <input type="checkbox" [checked]="data.status == 1"
                                        (change)="getAllocatedUsers(data, 'switch')">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="list-itm-content">
                        <div>
                            {{data.assignment_id}}
                        </div>
                        <div>
                            <span>Properties: </span><span>{{data.PropertyNo}}</span>
                        </div>
                        <div>
                              <span>Users: </span><span>{{data.Users}}</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="masterList?.length === 0">
                    <mat-card class="p-4 text-center "> <strong>No Record Found</strong> </mat-card>
                </div>
            </div>
        </div>
        <!-- BLOCK 1 END----------------------------------------------------------------------------------------------- -->

        <!-- BLOCK 2 START----------------------------------------------------------------------------------------------- -->

        <div id="block2" class="mcontainer">
            <div class="title">
                <span>Add Area</span>
            </div>
            <div class="property-id">
                <div *ngIf="selectedAssignment" class="w-100 d-flex justify-content-between">
                    <span>
                        <strong>Assignment Name - </strong>
                        {{selectedAssignment.label}}
                    </span>
                    <span *ngIf="selectedAssignment.status == -3" class="text-success">Archived</span>
                    <button *ngIf="selectedAssignment.status != -3" matTooltip="Archive Assignment" (click)="archiveAssignment()" class="archive-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M312.461 332.734H199.539c-8.511 0-15.434 6.923-15.434 15.434v34.634c0 8.511 6.923 15.435 15.434 15.435h112.923c8.511 0 15.435-6.923 15.435-15.435v-34.634c-.002-8.51-6.925-15.434-15.436-15.434zm-4.41 45.659H203.948v-25.814h104.103v25.814z" fill="#00ce2e" opacity="1" data-original="#000000" class=""></path><path d="m506.976 246.958.159-.08L432.73 99.774c-6.015-11.89-18.025-19.275-31.346-19.275h-14.141V66.824c0-5.48-4.442-9.922-9.922-9.922H134.68c-5.48 0-9.922 4.442-9.922 9.922v13.675h-14.141c-13.321 0-25.331 7.385-31.346 19.275L4.865 246.878l.159.08A34.54 34.54 0 0 0 0 264.939v155.409c0 19.162 15.59 34.751 34.752 34.751h442.497c19.162 0 34.751-15.59 34.751-34.751V264.939a34.54 34.54 0 0 0-5.024-17.981zm-119.734-144.41h14.141a13.02 13.02 0 0 1 11.671 7.179l60.93 120.462h-41.431v-37.066c0-5.48-4.442-9.922-9.922-9.922h-12.275v-53.227c0-5.48-4.442-9.922-9.922-9.922h-13.192v-17.504zm25.468 100.496v27.144h-52.359a22.925 22.925 0 0 0-20.865 13.482l-14.296 31.71a.841.841 0 0 1-.764.493H187.575a.84.84 0 0 1-.764-.494l-14.295-31.708a22.926 22.926 0 0 0-20.866-13.483H99.291v-27.144H412.71zM144.602 76.746h222.796v43.305H144.602V76.746zm245.91 63.149V183.2H121.488v-43.305h269.024zM98.946 109.727a13.017 13.017 0 0 1 11.671-7.179h14.141v17.503h-13.192c-5.48 0-9.922 4.442-9.922 9.922V183.2H89.369c-5.48 0-9.922 4.442-9.922 9.922v37.066H38.016l60.93-120.461zm378.303 323.322H34.752c-7.004 0-12.703-5.699-12.703-12.701V264.939c0-7.003 5.698-12.701 12.703-12.701H151.65c.328 0 .629.194.765.495l14.295 31.708a22.923 22.923 0 0 0 20.865 13.481h136.85a22.924 22.924 0 0 0 20.865-13.48l14.296-31.709v-.001a.84.84 0 0 1 .764-.494h116.898c7.004 0 12.701 5.699 12.701 12.701v155.409h.001c.001 7.004-5.697 12.701-12.701 12.701z" fill="#00ce2e" opacity="1" data-original="#000000" class=""></path></g></svg>
                    </button>
                </div>
                <span *ngIf="!selectedAssignment">
                    No assignments selected
                </span>
            </div>
            <div class="map-section rel">
                <img src="./assets/images/maps.png" alt="" class="str">
                <div class="overlay-button"></div>
                <div class="overlay-transparent">
                    <button *ngIf="selectedAssignment?.status != -3" (click)="openDialog('createMap')" [disabled]="get_assignmt_info_loader" id="draw" mat-button class="greenbutton size-sm">Draw on map</button>
                </div>
            </div>
            <div class="pad-10" fxLayout="row" fxLayoutAlign="space-between center">
                <div class="p-2">
                    <mat-checkbox class="checkB" (change)="select_all_unallocated($event)" [checked]="selected_unassProperties.length == filteredPropListPoly.length && filteredPropListPoly.length !=0" [disabled]="filteredPropListPoly.length == 0"></mat-checkbox>
                </div>
                <div fxFlex="85%">
                    <div class="inputbox">
                        <input class="search-input" placeholder="Search property" [formControl]="searchUnAssignProperty">
                        <mat-icon class="iconM">search</mat-icon>
                    </div>
                </div>
            </div>
            <div class="pad-5" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="selectedAssignment && selectedAssignment?.status != -3">
                <span>
                    <strong>Result : {{filteredPropListPoly.length == 0 ? 0: filteredPropListPoly.length}} of
                    {{getUnallocatedCount?.count ? getUnallocatedCount?.count : 0}}</strong>
                </span>

                <div class="fixed-width cnt" >
                    <button matTooltip="Property is active in another assignment of selected area" (click)="downloadProperty()" *ngIf="selectedAssignment && searchData?.body"><mat-icon>cloud_download</mat-icon></button>
                    <mat-select (selectionChange)="selectLimit(selectedLimit)" placeholder="Select Limit" [(ngModel)]="selectedLimit" class="form-select-l pagination">
                        <mat-option *ngFor="let limit of limtOption" [value]="limit">{{limit}}</mat-option>
                    </mat-select>
                </div>

            </div>
            <div id="mapProList" class="property-container2" (scroll)="onscroll($event)"  *ngIf="selectedAssignment && selectedAssignment?.status != -3">
                <div>
                    <ng-container>
                        <div *ngFor="let data of filteredPropListPoly" class="profile-list-item" [dndDraggable]="{type: 'Unallocated', data:data}" [dndEffectAllowed]="draggable.effectAllowed" (dndStart)="moveUnassigned($event, data.id)" (dndCanceled)="onDragCanceled($event,'unAssigned')">
                            <div class="pos">
                                <mat-checkbox class="checkB" (change)="checked_unAssignProperty($event, data)" [checked]="ifUnChecked(data.id)"></mat-checkbox>
                            </div>
                            <div class="profile-pic" [ngStyle]="{'background': 'linear-gradient(to top, black , transparent), url('+data.imageURL+')', 'background-repeat':'no-repeat', 'background-size': 'cover'}">
                                <div class="uid">{{data.uid}}</div>
                            </div>
                            <div class="property-info">
                                <div class="prop center">
                                    <span class="cp">{{data.property_name}}</span>
                                </div>
                                <div class="details">
                                    <div class="center first-item">
                                        <span class="clp1">Build Year: {{data.buildYear}}</span>
                                    </div>
                                    <div class="center second-item">
                                        <span class="clp1">Category: {{data.category}}</span>
                                    </div>
                                </div>
                                <div class="address" title="{{data.address}}">
                                    <p>{{data.address}}</p>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="unassignProploader" class='loader-div'>
                    <ngx-loading [show]="unassignProploader" [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.3)'}"></ngx-loading>
                </div>
                <div *ngIf="searchUnAssignProperty.value?.length > 0 && filteredPropListPoly?.length === 0">
                    <mat-card class="p-4 text-center "> <strong>No Record Found</strong> </mat-card>
                </div>
            </div>
        </div>
        <!-- BLOCK 2 END----------------------------------------------------------------------------------------------- -->

        <!-- BLOCK 3 START----------------------------------------------------------------------------------------------- -->
        <div class="mcontainer">
            <div class="title">
                <span>Allocate Users</span>
            </div>
            <div class="d-flex justify-content-between align-items-center p-1">
                <div class="inputbox">
                    <input class="search-input" placeholder="Search users by email" [formControl]="searchField">
                    <mat-icon class="iconM">search</mat-icon>
                </div>
                <button class="iconTick1" [disabled]="!selectedUserId.length" (click)="assignUser()" matTooltip="Allocate Users">
                    <img src="assets/icon/Check.svg" alt="">
                </button>
            </div>

            <div *ngIf="search_input" class="allocate1">
                <span *ngIf="selectedUserId.length == 0">Users not in this Assignment</span><br>
                <span *ngIf="selectedUserId.length > 0">Selected users: {{selectedUserId.length}}</span>
            </div>
            <div *ngIf="search_input" class="profile-list">
                <div *ngFor="let data of resultsList" class="profile-list-item">
                    <div class="pos">
                        <mat-checkbox value="{{data.id}}" class="checkB" [ngClass]="{'display-none': alreadyExisting == data.id}" [checked]="ischecked(data.id)" (change)="onCheckStatus($event)">
                        </mat-checkbox>
                    </div>
                    <div class="profile-pic">
                      <span *ngIf="alreadyExisting == data.id" class="user-already-existing">Already Assigned</span>
                        <img id="i-web" src="{{data.imageURL}}" alt="pic">
                    </div>
                    <div class="profile-info">

                        <div class="user" [ngClass]="{'danger': data.status == 0}">
                            <span [matTooltip]="(data.username?.length > 20)? data.username :''">{{(data.username?.length > 20) ? (data.username | slice:0:20)+'...': data.username}}</span>
                            <span matTooltip="QA/QC" class="star-icon" id="qaqc" *ngIf="is_qaqc_access(data.id) && alreadyExisting == data.id" (click)="updateQaqcAccess($event, data.id)">
                              <svg  xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="16" height="16" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g>
                                  <g xmlns="http://www.w3.org/2000/svg">
                                      <g>
                                          <polygon points="512,197.816 325.961,185.585 255.898,9.569 185.835,185.585 0,197.816 142.534,318.842 95.762,502.431     255.898,401.21 416.035,502.431 369.263,318.842   " fill="#0cce54" data-original="#000000" class=""></polygon>
                                      </g>
                                  </g>
                                  </g></svg>
                          </span>
                          <span matTooltip="QA/QC" class="star-icon" id="!qaqc" *ngIf="!is_qaqc_access(data.id) && alreadyExisting == data.id" (click)="updateQaqcAccess($event, data.id)">
                              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="16" height="16" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g>
                                  <g xmlns="http://www.w3.org/2000/svg">
                                      <g>
                                          <path d="M512,197.819l-185.933-12.228L256,9.571l-70.067,176.021L0,197.82l142.658,120.93L95.856,502.429L256,401.214    l160.144,101.215l-46.8-183.671L512,197.819z M256,365.724l-112.464,71.08l32.827-128.831L75.829,222.888l130.971-8.603    L256,90.687l49.2,123.599l131.124,8.602l-100.689,85.077l32.829,128.839L256,365.724z" fill="#323232" data-original="#000000" class=""></path>
                                      </g>
                                  </g>
                              </g></svg>
                          </span>
                            <div class="center load">
                                <span>{{countProperty(data.id)}}</span>
                            </div>
                        </div>
                        <div class="mail over" [matTooltip]="(data.mail?.length > 30)? data.mail :''">
                            <span class="w100">Mail: </span> <small  class="w100">{{(data.mail?.length > 30) ? (data.mail | slice:0:30)+'...': data.mail}}</small>
                        </div>
                        <div class="contact">
                            Contact:<span>{{data.contact}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!search_input" class="allocate">
                <button [ngClass]="{'border-blue':property_drop}" (click)="getPropertyByAssignment(0)" dndDropzone (dndDrop)="onDrop($event, 'Unallocated')" id="draw" mat-button class="greybutton border size-md">Unallocated
                    Properties (<span class="bl">{{countProperty(0)}}</span>)</button>
            </div>
            <div *ngIf="loader3" class='loader-div'>
                <ngx-loading [show]="loader3" [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.3)'}">
                </ngx-loading>
            </div>
            <div *ngIf="!search_input">

                <div id="block3" class="profile-list">
                    <div *ngFor="let data of filteredUserList" [ngClass]="{'border-blue':property_drop, 'activeUser':isActiveUser(data.id) && data.status == 1, 'activeDisabledUser':isActiveUser(data.id) && data.status == 0}" class="profile-list-item" [dndDraggable]="data"
                        [dndEffectAllowed]="draggable.effectAllowed" (dndStart)="onDragStart($event,'user')" (dndCanceled)="onDragCanceled($event,'user')" dndDropzone (dndDrop)="onDrop($event, {type: 'droppedonuser', data: data})" (click)="getPropertyByAssignment(data.id)">
                        <div class="profile-pic">
                            <img id="i-web" src="{{data.imageURL}}" alt="pic">
                        </div>
                        <div class="profile-info">
                            <div class="user" [ngClass]="{'danger': data.status == 0}">
                                <div class="cp" style="display: flex;">
                                    <span>{{data.username}}</span>
                                    <span matTooltip="QA/QC" class="star-icon" id="qaqc" *ngIf="is_qaqc_access(data.id)" (click)="updateQaqcAccess($event, data.id)">
                                        <svg  xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="16" height="16" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g>
                                            <g xmlns="http://www.w3.org/2000/svg">
                                                <g>
                                                    <polygon points="512,197.816 325.961,185.585 255.898,9.569 185.835,185.585 0,197.816 142.534,318.842 95.762,502.431     255.898,401.21 416.035,502.431 369.263,318.842   " fill="#0cce54" data-original="#000000" class=""></polygon>
                                                </g>
                                            </g>
                                            </g></svg>
                                    </span>
                                    <span matTooltip="QA/QC" class="star-icon" id="!qaqc" *ngIf="!is_qaqc_access(data.id)" (click)="updateQaqcAccess($event, data.id)">
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="16" height="16" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g>
                                            <g xmlns="http://www.w3.org/2000/svg">
                                                <g>
                                                    <path d="M512,197.819l-185.933-12.228L256,9.571l-70.067,176.021L0,197.82l142.658,120.93L95.856,502.429L256,401.214    l160.144,101.215l-46.8-183.671L512,197.819z M256,365.724l-112.464,71.08l32.827-128.831L75.829,222.888l130.971-8.603    L256,90.687l49.2,123.599l131.124,8.602l-100.689,85.077l32.829,128.839L256,365.724z" fill="#323232" data-original="#000000" class=""></path>
                                                </g>
                                            </g>
                                        </g></svg>
                                    </span>
                                </div>

                                <div class="center spacing">
                                    <span>{{countProperty(data.id)}}</span>
                                    <mat-icon title="Unallocate user" (click)="openDialog('existingProp',{'user':data})" class="small" [ngClass]="{'danger': data.status == 0}" svgIcon="delete"></mat-icon>
                                </div>
                            </div>
                            <div class="mail">
                                <span> Mail:&nbsp;</span>
                                <p class="over">{{data.mail}}</p>
                            </div>
                            <div class="contact">
                                <span>Contact:&nbsp;</span> <small class="w100">{{data.contact}}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- BLOCK 3 END ----------------------------------------------------------------------------------------------- -->
        <!-- BLOCK 4 START ----------------------------------------------------------------------------------------------- -->
        <div class="mcontainer">
            <div class="title-ap">
                <span style="font-size: 12.5px !important;">Display Properties</span>
                <span *ngIf="propertyList.length > 0" style="font-size: 12.5px !important;">
                    | Deallocate :
                    <button class="_btn" (click)="openConfirmation()">Selected</button>
                    <button class="_btn" (click)="openConfirmation(true)">All</button>
                </span>
            </div>
            <div class="cent">
                <div class="p-2">
                    <mat-checkbox class="checkB" (change)="select_all($event)" [checked]="selected_properties.length == propertyList.length && propertyList.length !=0" [disabled]="propertyList.length == 0"></mat-checkbox>
                </div>
                <div class="fixed-width cnt">
                    <mat-select (selectionChange)="selectNeighbourhoodParent(selectedNeighUid)" (openedChange)="searchText=''" placeholder="Select Neighbourhood" [(ngModel)]="selectedNeighUid" class="form-select-l">
                        <div class="search_bar"> <input mat-input [(ngModel)]="searchText" placeholder="Type here to search name..." (keydown)="$event.stopPropagation()" /></div>
                        <mat-option *ngFor="let neigh of neighbourhoods | searchfilter:'neigh_name':searchText:neighbourhoods" [value]="neigh.neigh_uid">{{neigh.neigh_name}}</mat-option>
                    </mat-select>
                </div>
                <div class="" *ngIf="filteredUserList">
                    <div class="inputbox">
                        <input class="search-input" placeholder="Search property" [formControl]="searchproperty">
                        <mat-icon class="iconM">search</mat-icon>
                    </div>
                </div>
            </div>
            <div *ngIf="propertyBlock4" class="status-filter">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <button mat-raised-button class="all-btn1" (click)="filterProperty('1,2,3,4,5,6,7')" [ngClass]="('1,2,3,4,5,6,7' == statusfilter)?'selection-br':''" title="Select all">
                        <img class="all-select" src="./assets/images/selectAll.png" alt="All">
                      </button>
                        <div class="center" *ngFor="let sts of statusList" [ngClass]="(sts.status == statusfilter)?'selectedFilter':''" matTooltip="{{getTitlefilter(sts.status)}}" matTooltipPosition="above" (click)="filterProperty(sts.status)">
                            <i class="material-icons" [ngClass]="{'yellow': sts.status == 1, 'green': sts.status == 5,'orange': sts.status == '2','blue': sts.status == '7' , 'red': sts.status == '3,4,6'}">fiber_manual_record</i>
                        </div>
                    </div>
                    <div>
                        <mat-select (selectionChange)="selectPropertyLimit(propertyLimit)" placeholder="Select Limit" [(ngModel)]="propertyLimit" class="form-select-l">
                            <mat-option *ngFor="let limit of limtOption" [value]="limit">{{limit}}</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>
            <div id="block4" class="property-container" (scroll)="onscrollProperty($event)">
                <div *ngIf="propertyBlock4">
                    <div *ngIf="loader4" class='loader-div'>
                        <ngx-loading [show]="loader4" [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.3)'}">
                        </ngx-loading>
                    </div>
                    <div *ngFor="let data of propertyList" class="profile-list-item" [dndDraggable]="{type: 'prop', data: data}" [dndEffectAllowed]="draggable.effectAllowed" (dndStart)="onDragStart($event,'property', data.id)" (dndCanceled)="onDragCanceled($event,'property')">
                        <div class="pos">
                            <mat-checkbox class="checkB" (change)="checked_property($event, data)" [checked]="ifChecked(data.id)"></mat-checkbox>
                        </div>
                        <div class="profile-pic" [ngStyle]="{'background': 'linear-gradient(to top, black , transparent), url('+data.imageURL+')', 'background-repeat':'no-repeat', 'background-size': 'cover'}">
                            <div class="uid">{{data.uid}}</div>
                        </div>
                        <div class="property-info">
                            <div class="prop center">
                                <span class="cp">{{data.property_name}}</span>
                                <div class="center" matTooltip="{{getTitle(data.status)}}" matTooltipPosition="left">
                                    <i class="material-icons" [ngClass]="{'yellow': data.status == 1, 'green': data.status == 5,'orange': data.status == 2, 'blue': data.status == 7 , 'red': data.status == -3 || data.status == 4 || data.status == 6 }">fiber_manual_record</i>
                                </div>
                            </div>
                            <div class="details">
                                <div class="center first-item">
                                    <span class="clp1">Build Year: {{data.buildYear}}</span>
                                </div>
                                <div class="center second-item">
                                    <span class="clp1">Category: {{data.category}}</span>
                                </div>
                            </div>
                            <div class="address" title="{{data.address}}">
                                <p>{{data.address}}</p>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="propertyList?.length === 0">
                        <mat-card class="p-4 text-center "> <strong>No Record Found</strong> </mat-card>
                    </div>
                </div>
            </div>
        </div>
        <!-- BLOCK 4 END ----------------------------------------------------------------------------------------------- -->
    </div>
</div>
